// extracted by mini-css-extract-plugin
export default {"select_locale":"Home_select_locale__DTxMw","flags":"Home_flags__uH6gX","small_hero":"Home_small_hero__AodKy","row_hero":"Home_row_hero__9SSWI"};